var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component articleTitle stock-top"},[_c('div',{staticClass:"stock-header"},[_c('div',{staticClass:"line inline"}),_c('div',{staticClass:"text inline"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }